/**
 * Enigmas da Festa da História — Cidadela de Bragança.
 * Pins: use `plusCode` (Google Maps) or `position` [lat, lng].
 *
 * Respostas: validadas sem distinguir maiúsculas/minúsculas nem acentos.
 * Placeholders (a definir) marcados em `answerPending: true`.
 */
import { resolvePlusCode } from '../utils/plusCode';

export const ENIGMAS = [
  {
    id: 'quem-e-quem',
    number: 1,
    title: 'Área de jogos',
    body: `De azul se veste, ocultando o semblante,
e a sua presença é deveras inquietante.
Muitos no reino dele sentem temor,
mas eu só consigo vê-lo com amor.

Em segredo, por ele o meu coração bate,
mesmo que o seu ofício a muitos assuste.
Se procuras aquele que me faz suspirar,
procura quem nunca larga o seu machado ao caminhar.`,
    plusCode: 'R732+J4P Bragança',
    position: resolvePlusCode('R732+J4P Bragança'),
    answer: 'carrasco',
    acceptedAnswers: ['o carrasco'],
    answerPending: true,
    nearMisses: [],
  },
  {
    id: 'espada',
    number: 2,
    title: 'O Celta',
    body: '',
    plusCode: 'R63X+HX8 Bragança',
    position: resolvePlusCode('R63X+HX8 Bragança'),
    answer: 'espada',
    acceptedAnswers: ['espada'],
    nearMisses: [],
  },
  {
    id: 'princesa',
    number: 3,
    title: 'Domus Municipalis',
    body: '',
    plusCode: 'R732+99Q Bragança',
    position: resolvePlusCode('R732+99Q Bragança'),
    answer: 'princesa',
    acceptedAnswers: ['princesa'],
    nearMisses: [
      {
        value: 'a resposta que procuras princesa',
        hint: 'Apenas uma palavra',
      },
    ],
  },
  {
    id: 'mercenarios',
    number: 5,
    title: 'Direção: Rua dos Larápios/WC',
    body: '',
    plusCode: 'R732+976 Bragança',
    position: resolvePlusCode('R732+976 Bragança'),
    answer: 'LII',
    acceptedAnswers: ['lii'],
    nearMisses: [
      {
        value: '52',
        hint: 'Talvez não seja esta a representação',
      },
      {
        value: 'cinquenta e dois',
        hint: 'Talvez não seja esta a representação',
      },
    ],
  },
  {
    id: 'brasoes',
    number: 6,
    title: 'O Poço',
    body: '',
    plusCode: 'R63X+6XJ Bragança',
    position: resolvePlusCode('R63X+6XJ Bragança'),
    answer: 'escudo',
    acceptedAnswers: [],
    answerPending: true,
    nearMisses: [],
  },
  {
    id: 'assassinato',
    number: 7,
    title: 'Zé Tuga',
    body: 'Quem será o culpado do assassinato? Onde aconteceu? E com que objeto?',
    plusCode: 'R732+CG8 Bragança',
    position: resolvePlusCode('R732+CG8 Bragança'),
    /** Três espaços: local, objeto, culpado */
    fields: [
      {
        id: 'local',
        label: 'Local',
        answer: 'castelo',
        acceptedAnswers: ['castelo'],
        answerPending: true,
      },
      {
        id: 'objeto',
        label: 'Objeto',
        answer: 'cálice',
        acceptedAnswers: ['cálice'],
        answerPending: true,
      },
      {
        id: 'culpado',
        label: 'Culpado',
        answer: 'princesa',
        acceptedAnswers: ['princesa'],
        answerPending: true,
      },
    ],
    answerPending: true,
  },
];

export const STORAGE_KEY = 'festa-historia-braganca-v2';

/** Local final — Escape Room Bragança (aparece quando todos os enigmas estão resolvidos) */
export const FINALE_LOCATION = {
  id: 'maquina-do-tempo',
  name: 'Escape Room Bragança',
  position: [41.800879781940424, -6.764096617732386],
  message: 'Conseguimos localizar com precisão o esconderijo',
  urgency:
    'O esconderijo do Viajante do Tempo foi localizado e precisamos de parar urgentemente o próximo plano dele.',
  photoTitle: 'A PROVA',
  photoLead:
    'Desloca-te à banca da Escape Room Bragança, na Festa da História, e tira a fotografia oficial de conclusão do desafio.',
  discountCode: 'FestaHistoria',
  discountPercent: 25,
  discountUntilLabel: 'dia 18',
};

export function getEnigma(id) {
  return ENIGMAS.find((e) => e.id === id);
}
